<ion-header>
  <ion-toolbar>
    <ion-title>Suscripción</ion-title>
    <ion-buttons slot="start">
      <ion-back-button
        defaultHref="/tecservice-transportec/subscription/subscribe-radial"
        color="primary"
      ></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-grid style="height: 100%">
    <ion-row class="ion-align-items-center ion-justify-content-center">
      <h3>Hola, {{user?.name}} {{user?.lastname}}</h3>
      <div *ngIf="mySubscription">
        <ion-row *ngIf="mySubscription.school_period">
          <ion-col size="3">
            <ion-icon src="/assets/icon/id.svg" color="primary"></ion-icon>
          </ion-col>
          <ion-col size="9">
            <p>
              ¡Las inscripciones para el periodo escolar
              <u>
                <strong>
                  {{mySubscription.school_period.name}} {{ mySubscription.slot_id ? ' - '+mySubscription.slot_name: ''}}
                </strong>
              </u>
              están abiertas y ya puedes escoger ruta y horario!
            </p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="3">
            <ion-icon [src]="'/assets/icon/'+mySubscription.name.toLowerCase()+'.svg'" color="primary"></ion-icon>
          </ion-col>
          <ion-col size="9">
            <p>
              Tu suscripción al servicio de transporte es
              <u><strong *ngIf="mySubscription">{{mySubscription.fullname}}</strong></u>
              .
            </p>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="mySubscription && mySubscription.status === 0">
          <ion-col size="3">
            <ion-icon src="/assets/icon/location-pin.svg" color="primary"></ion-icon>
          </ion-col>
          <ion-col size="9">
            <p>
              Tienes derecho a escoger
              <u>una</u>
              ruta y horario por día, de
              <u>
                <strong *ngIf=" mySubscription && mySubscription.type==='complete'">llegada y salida</strong>
                <strong *ngIf=" mySubscription && mySubscription.type==='go'">llegada</strong>
                <strong *ngIf=" mySubscription && mySubscription.type==='return'">salida</strong>
              </u>
              <u><strong *ngIf=" mySubscription && mySubscription.zone_name">{{mySubscription.zone_name}}</strong></u>
              .
            </p>
            <p class="danger" *ngIf="mySubscription && mySubscription.status === -1">
              El periodo de suscripción ha expirado.
            </p>
          </ion-col>
        </ion-row>
      </div>
      <ion-button
        shape="round"
        color="primary"
        expand="block"
        (click)="next()"
        [disabled]="!mySubscription || mySubscription.status === -1"
      >
        Siguiente
      </ion-button>
    </ion-row>
  </ion-grid>
</ion-content>
